import { defineAction } from '_utils/redux'
import * as providerService from '_services/provider'
import { notEmptyPayload, parseNumber, formatDateDays } from '_utils/helpers'
import { PROVIDER_FIELDS } from '_views/provider/constants'

export const GET_PROVIDERS = defineAction('GET_PROVIDERS')
export const GET_PROVIDERS_LIST = defineAction('GET_PROVIDERS_LIST')
export const GET_AGENCY_PROVIDERS = defineAction('GET_AGENCY_PROVIDERS')
export const GET_PROVIDER = defineAction('GET_PROVIDER')
export const GET_NEXT_PAGE_PROVIDERS = defineAction('GET_NEXT_PAGE_PROVIDERS')
export const GET_NEXT_PAGE_AGENCY_PROVIDERS = defineAction('GET_NEXT_PAGE_AGENCY_PROVIDERS')
export const GET_NEXT_PAGE_LIST_PROVIDERS = defineAction('GET_NEXT_PAGE_LIST_PROVIDERS')
export const UPDATE_PROVIDER = defineAction('UPDATE_PROVIDER')
export const GET_PROVIDERS_FILTERED = defineAction('GET_PROVIDERS_FILTERED')
export const GET_PROVIDERS_LIST_FILTERED = defineAction('GET_PROVIDERS_LIST_FILTERED')
export const GET_PROVIDERS_WITH_NO_PAGINATION = defineAction('GET_PROVIDERS_WITH_NO_PAGINATION')
export const GET_PROVIDERS_V2_WITH_NO_PAGINATION = defineAction(
  'GET_PROVIDERS_V2_WITH_NO_PAGINATION'
)
export const CREATE_PROVIDER = defineAction('CREATE_PROVIDER')
export const DELETE_PROVIDER_ATTACHMENT = defineAction('DELETE_PROVIDER_ATTACHMENT')
export const ADD_PROVIDER_STAFF_USER = defineAction('ADD_PROVIDER_STAFF_USER')
export const DELETE_PROVIDER_STAFF_USER = defineAction('DELETE_PROVIDER_STAFF_USER')
export const UPDATE_PROVIDER_STAFF_USER = defineAction('UPDATE_PROVIDER_STAFF_USER')
export const SET_TABLE_PAGE = 'SET_TABLE_PAGE'
export const SET_AGENCY_PROVIDERS_TABLE_PAGE = 'SET_AGENCY_PROVIDERS_TABLE_PAGE'
export const SET_FILTER = 'SET_FILTER'
export const SET_FILTER_AGENCY_PROVIDER = 'SET_FILTER_AGENCY_PROVIDER'
export const SET_PROVIDERS_NO_PAGINATION = 'SET_PROVIDERS_NO_PAGINATION'
export const CREATE_PROVIDER_CONTRACT = defineAction('CREATE_PROVIDER_CONTRACT')
export const DELETE_PROVIDER_CONTRACT = defineAction('DELETE_PROVIDER_CONTRACT')
export const GET_CONNECTION_MESSAGE_TOOL = defineAction('GET_CONNECTION_MESSAGE_TOOL')
export const GET_SUGGESTIONS_PROVIDERS = defineAction('GET_SUGGESTIONS_PROVIDERS')
export const VALIDATE_CPF_CNPJ = defineAction('VALIDATE_CPF_CNPJ')
export const PATCH_AGENCY_PROVIDER_LINK = defineAction('PATCH_AGENCY_PROVIDER_LINK')
export const DELETE_AGENCY_PROVIDER_LINK = defineAction('DELETE_AGENCY_PROVIDER_LINK')

export const GET_PROVIDERS_ORDERS = defineAction('GET_PROVIDERS_ORDERS')
export const GET_LEAD_PROVIDERS = defineAction('GET_LEAD_PROVIDERS')
export const IMPORT_LEAD_PROVIDERS = defineAction('IMPORT_LEAD_PROVIDERS')
export const REQUEST_REFERA_PROVIDERS = defineAction('REQUEST_REFERA_PROVIDERS')

export const RATE_PROVIDER = defineAction('RATE_PROVIDER')
export const GET_PROVIDER_RATES = defineAction('GET_PROVIDER_RATES')
export const UPDATE_PROVIDER_RATE = defineAction('UPDATE_PROVIDER_RATE')

const formatPayload = values => {
  const payload = notEmptyPayload(values)

  if (payload[PROVIDER_FIELDS.PHONE]) {
    payload[PROVIDER_FIELDS.PHONE] = parseNumber(payload[PROVIDER_FIELDS.PHONE])
  }

  if (payload[PROVIDER_FIELDS.CNPJ]) {
    payload[PROVIDER_FIELDS.CNPJ] = parseNumber(payload[PROVIDER_FIELDS.CNPJ])
  }

  if (payload[PROVIDER_FIELDS.BANK_ACCOUNT_CPF_CNPJ]) {
    payload[PROVIDER_FIELDS.BANK_ACCOUNT_CPF_CNPJ] = parseNumber(
      payload[PROVIDER_FIELDS.BANK_ACCOUNT_CPF_CNPJ]
    )
  }

  if (payload[PROVIDER_FIELDS.COMPANY_CREATION_DATE]) {
    payload[PROVIDER_FIELDS.COMPANY_CREATION_DATE] = formatDateDays(
      payload[PROVIDER_FIELDS.COMPANY_CREATION_DATE],
      'dd/MM/yyyy',
      'yyyy-MM-dd'
    )
  }

  if (payload[PROVIDER_FIELDS.MAIN_SERVICES]) {
    const formattedService = formatMainService(payload[PROVIDER_FIELDS.MAIN_SERVICES])
    return {
      ...payload,
      mainServices: formattedService?.mainServices,
      mainServiceTypes: formattedService?.mainServiceTypes,
    }
  }
  if (typeof payload[PROVIDER_FIELDS.BRAND_LOGO_PNG_URL] === 'string') {
    delete payload[PROVIDER_FIELDS.BRAND_LOGO_PNG_URL]
  }
  return payload
}

const formatMainService = items => {
  return items.reduce(
    (acc, item) => ({
      mainServices: [...acc.mainServices, item?.category],
      mainServiceTypes: [...acc.mainServiceTypes, item?.category],
    }),
    { mainServices: [], mainServiceTypes: [] }
  )
}

export const getProviders = params => async (dispatch, getState) => {
  const queryParams = {
    pageSize: params?.pageSize || getState().providers.size,
  }
  const data = await providerService.getProviders(getState().user.authToken)(queryParams)
  dispatch({
    type: GET_PROVIDERS.ACTION,
    payload: async () => data,
    meta: queryParams,
  })
  return data
}

export const getProvidersList = params => async (dispatch, getState) => {
  const queryParams = {
    ...params,
    pageSize: params?.pageSize || getState().providers.size,
  }
  const data = await providerService.getProvidersList(getState().user.authToken)(queryParams)
  dispatch({
    type: GET_PROVIDERS_LIST.ACTION,
    payload: async () => data,
    meta: queryParams,
  })
  return data
}

export const getAgencyProviders = params => async (dispatch, getState) => {
  const queryParams = {
    ...params,
  }
  const promise = providerService.getAgencyProviders(getState().user.authToken)(queryParams)
  dispatch({
    type: GET_AGENCY_PROVIDERS.ACTION,
    payload: promise,
    meta: queryParams,
  })
  return promise
}

export const getProvider = (providerId, params) => async (dispatch, getState) => {
  const data = await providerService.getProvider(getState().user.authToken)(providerId, params)

  dispatch({
    type: GET_PROVIDER.ACTION,
    payload: async () => data,
  })

  return data
}

export const getAgencyProvidersNextPage = params => (dispatch, getState) => {
  const queryParams = {
    agencyId: params?.agencyId,
    pageSize: params?.pageSize || getState().providers.agencyProviders.size,
    page: params.page,
    ...params.filters,
  }

  dispatch({
    type: GET_NEXT_PAGE_AGENCY_PROVIDERS.ACTION,
    payload: providerService.getAgencyProviders(getState().user.authToken)(queryParams),
  })
}

export const getProvidersNextPage = params => (dispatch, getState) => {
  const queryParams = {
    pageSize: params?.pageSize || getState().providers.size,
    page: params.page,
    ...params.filters,
  }

  dispatch({
    type: GET_NEXT_PAGE_PROVIDERS.ACTION,
    payload: providerService.getProviders(getState().user.authToken)(queryParams),
  })
}

export const getProvidersListNextPage = params => (dispatch, getState) => {
  const queryParams = {
    pageSize: params?.pageSize || getState().providers.size,
    page: params.page,
    ...params.filters,
  }

  dispatch({
    type: GET_NEXT_PAGE_LIST_PROVIDERS.ACTION,
    payload: providerService.getProvidersList(getState().user.authToken)(queryParams),
  })
}

export const getProvidersFiltered =
  (filters = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: GET_PROVIDERS_FILTERED.ACTION,
      payload: providerService.getProviders(getState().user.authToken)({
        ...getState().providers.filter.toJS(),
        ...filters,
      }),
    })
  }

export const getProvidersListFiltered =
  (filters = {}) =>
  (dispatch, getState) => {
    dispatch({
      type: GET_PROVIDERS_LIST_FILTERED.ACTION,
      payload: providerService.getProvidersList(getState().user.authToken)({
        ...getState().providers.filter.toJS(),
        ...filters,
      }),
    })
  }

export const getProvidersWithoutPagination =
  (filters = {}) =>
  async (dispatch, getState) => {
    const data = await providerService.getProviders(getState().user.authToken)({
      ...getState().providers.filter.toJS(),
      ...filters,
      pageSize: 'none',
    })
    dispatch({
      type: GET_PROVIDERS_WITH_NO_PAGINATION.ACTION,
      payload: async () => data,
    })
    return data
  }

/**
 *
 * @param {Object} params
 * @param {Object} params.filters - Filters to apply
 * @param {Array} [params.filters.providerOrigin] - Array of provider origins to filter by. If not provided, it will throw an error if attemptMany is false.
 * @param {boolean} [params.attemptMany] - If true, will attempt to fetch providers from multiple origins by itself. Used for the process of fetching providers before the modal is opened. Defaults to false.
 * @returns
 */
export const getProvidersV2WithoutPagination =
  ({ filters = {}, attemptMany = false }) =>
  async (dispatch, getState) => {
    if (!attemptMany && !filters?.providerOrigin) {
      throw new Error('"filters" parameter should contain providerOrigin if attemptMany is false')
    }

    const providerOrigin = attemptMany
      ? ['my_providers', 'imported_from_refera']
      : filters?.providerOrigin

    const currentFilters = {
      ...getState().providers.filter.toJS(),
      ...filters,
      pageSize: 'none',
      paused: false,
      providerOrigin: providerOrigin.join(','),
    }

    let data

    try {
      data = await providerService.getProvidersByOrigin(getState().user.authToken)(currentFilters)
    } catch (error) {
      if (attemptMany && error?.error_message) {
        currentFilters.providerOrigin = ['refera'].join(',')
        // If the error is due to no providers found, we will try to fetch from 'refera' origin
        // If it fails, we will throw the error
        // If the second thrown error doesn't have a debug_error, it's likely a validation error related to no providers found or providers import limit reached
        try {
          data = await providerService.getProvidersByOrigin(getState().user.authToken)(
            currentFilters
          )
        } catch (attemptManyError) {
          data = []
          dispatch({
            type: SET_PROVIDERS_NO_PAGINATION,
            payload: async () => data,
          })
          // Return empty data with error info to maintain error_message from backend
          return {
            providers: [],
            origin: [],
            error: attemptManyError,
          }
        }
      } else {
        // not attemptMany or not a validation error
        throw error
      }
    }

    dispatch({
      type: GET_PROVIDERS_V2_WITH_NO_PAGINATION.ACTION,
      payload: async () => data,
    })

    if (!data?.length) return { providers: [], origin: [] } // should never happen because of the attemptMany logic. Throws an error if no providers are found
    return {
      providers: data,
      origin: currentFilters.providerOrigin.split(','), // Return the provider origin as an array
    }
  }

export const setTablePage = page => dispatch =>
  dispatch({
    type: SET_TABLE_PAGE,
    payload: page,
  })

export const setAgencyProvidersTablePage = page => dispatch =>
  dispatch({
    type: SET_AGENCY_PROVIDERS_TABLE_PAGE,
    payload: page,
  })

export const updateProvider = payload => (dispatch, getState) => {
  const providerId = getState().providers.currentProvider
  const data = providerService.updateProvider(getState().user.authToken)(
    providerId,
    formatPayload(payload)
  )
  dispatch({
    type: UPDATE_PROVIDER.ACTION,
    payload: data,
  })
  return data
}

export const patchAgencyProviderLink =
  (companyId, agencyId, payload) => async (dispatch, getState) => {
    const data = await providerService.patchAgencyProviderLink(getState().user.authToken)(
      companyId,
      agencyId,
      payload
    )
    dispatch({
      type: PATCH_AGENCY_PROVIDER_LINK.ACTION,
      payload: async () => data,
      meta: { companyId },
    })
    return data
  }

export const deleteAgencyProviderLink = (companyId, agencyId) => async (dispatch, getState) => {
  const data = await providerService.deleteAgencyProviderLink(getState().user.authToken)(
    companyId,
    agencyId
  )
  dispatch({
    type: DELETE_AGENCY_PROVIDER_LINK.ACTION,
    payload: async () => data,
    meta: { companyId },
  })
  return data
}

export const deleteProviderAttachment = attachmentId => (dispatch, getState) => {
  const providerId = getState().providers.currentProvider

  dispatch({
    type: DELETE_PROVIDER_ATTACHMENT.ACTION,
    payload: providerService.deleteProviderAttachment(getState().user.authToken)(
      providerId,
      attachmentId
    ),
    meta: { attachmentId, providerId },
  })
}

export const deleteProviderContract = attachmentId => (dispatch, getState) => {
  const providerId = getState().providers.currentProvider

  dispatch({
    type: DELETE_PROVIDER_CONTRACT.ACTION,
    payload: providerService.deleteProviderContract(getState().user.authToken)(
      providerId,
      attachmentId
    ),
    meta: { attachmentId, providerId },
  })
}

export const createProviderContract = payload => (dispatch, getState) => {
  const providerId = getState().providers.currentProvider
  const data = providerService.createProviderContract(getState().user.authToken)(
    providerId,
    formatPayload(payload)
  )
  dispatch({
    type: CREATE_PROVIDER_CONTRACT.ACTION,
    payload: data,
  })
  return data
}

export const setFilter = param => dispatch =>
  dispatch({
    type: SET_FILTER,
    payload: param,
  })

export const setFilterAgencyProviders = param => dispatch =>
  dispatch({
    type: SET_FILTER_AGENCY_PROVIDER,
    payload: param,
  })

export const createProvider = payload => (dispatch, getState) => {
  const data = providerService.createProvider(getState().user.authToken)(formatPayload(payload))
  dispatch({
    type: CREATE_PROVIDER.ACTION,
    payload: data,
  })
  return data
}

export const addProviderStaffUser = payload => (dispatch, getState) => {
  const providerId = getState().providers.currentProvider
  const data = providerService.addProviderStaffUser(getState().user.authToken)(providerId, payload)

  dispatch({
    type: ADD_PROVIDER_STAFF_USER.ACTION,
    payload: providerService.addProviderStaffUser(getState().user.authToken)(providerId, payload),
    meta: { providerId },
  })

  return data
}

export const deleteProviderStaffUser = staffId => (dispatch, getState) => {
  const providerId = getState().providers.currentProvider
  const data = providerService.deleteProviderStaffUser(getState().user.authToken)(
    providerId,
    staffId
  )

  dispatch({
    type: DELETE_PROVIDER_STAFF_USER.ACTION,
    payload: data,
    meta: { providerId },
  })

  return data
}

export const updateProviderStaffUser = payload => (dispatch, getState) => {
  const providerId = getState().providers.currentProvider
  const data = providerService.updateProviderStaffUser(getState().user.authToken)(
    providerId,
    payload,
    payload.id
  )

  dispatch({
    type: UPDATE_PROVIDER_STAFF_USER.ACTION,
    payload: data,
    meta: { providerId },
  })

  return data
}

export const getConnetionMessageTool = params => (dispatch, getState) => {
  const data = providerService.getConnetionMessageTool(getState().user.authToken)(params)

  dispatch({
    type: GET_CONNECTION_MESSAGE_TOOL.ACTION,
    payload: data,
  })

  return data
}

export const getProviderSuggestionsList = payload => async (dispatch, getState) => {
  const data = await providerService.getProviderSuggestionsList(getState().user.authToken)(payload)

  dispatch({
    type: GET_SUGGESTIONS_PROVIDERS.ACTION,
    payload: async () => data,
  })

  return data
}

export const getProvidersOrders = params => async (dispatch, getState) => {
  const data = await providerService.getProviderOrders(getState().user.authToken)(params)

  dispatch({
    type: GET_PROVIDERS_ORDERS.ACTION,
    payload: async () => data,
    meta: params,
  })

  return data
}

export const getLeadProviders = params => async (dispatch, getState) => {
  const data = await providerService.getLeadProviders(getState().user.authToken)(params)

  dispatch({
    type: GET_LEAD_PROVIDERS.ACTION,
    payload: async () => data,
  })

  return data
}

export const importLeadProviders = payload => async (dispatch, getState) => {
  const data = await providerService.importLeadProviders(getState().user.authToken)(payload)

  dispatch({
    type: IMPORT_LEAD_PROVIDERS.ACTION,
    payload: async () => data,
  })

  return data
}

export const validateProviderCpfCnpj = params => async (dispatch, getState) => {
  const data = await providerService.validateProviderCpfCnpj(getState().user.authToken)(params)

  dispatch({
    type: VALIDATE_CPF_CNPJ.ACTION,

    payload: async () => data,
  })

  return data
}

export const getProviderRates = params => async (dispatch, getState) => {
  const data = await providerService.getProviderRates(getState().user.authToken)(params)

  dispatch({
    type: GET_PROVIDER_RATES.ACTION,
    payload: async () => data,
  })

  return data
}

export const requestReferaProviders = payload => async (dispatch, getState) => {
  const data = await providerService.requestReferaProviders(getState().user.authToken)(payload)

  dispatch({
    type: GET_PROVIDER_RATES.ACTION,
    payload: async () => data,
  })

  return data
}

export const rateProvider = payload => (dispatch, getState) => {
  const data = providerService.rateProvider(getState().user.authToken)(payload)

  dispatch({
    type: RATE_PROVIDER.ACTION,
    payload,
  })

  return data
}

export const updateProviderRate = (id, payload) => (dispatch, getState) => {
  const data = providerService.updateProviderRate(getState().user.authToken)(id, payload)

  dispatch({
    type: UPDATE_PROVIDER_RATE.ACTION,
    payload,
  })

  return data
}
